import React, { useCallback, useEffect, useState } from 'react'
import Slider from 'react-slick';
import * as styles from './CarouselFilters.module.scss';
import { FilterOptions, FilterTypes, SelectedFilters } from '../Filters/Filters';
import { FilterItem, FilterProps } from '../../typings';
import { fetchfilters } from '../../services/common.service';

interface CarouselFiltersProps {
    onFilterSelect: (newFilters: Set<string>) => void; 
    initialFilters: SelectedFilters;
    keyword?: string;
    reset?: boolean;
}

// get the filters selected in settings
interface Window {
  cg_jobs_es_var?: { pathName ?: string};
  cg_jobs_country_code?: string;
}
const countryCodeinSettings = (window as Window).cg_jobs_country_code;
const cCode = countryCodeinSettings ? countryCodeinSettings : (window as Window).cg_jobs_es_var?.pathName;
 export const CarouselFilters: React.FC<CarouselFiltersProps> = ({onFilterSelect, initialFilters, keyword, reset}) => {   
  const [selectedCarouselFilters, setSelectedCarouselFilters] = useState<Set<string>>(new Set(Array.from(initialFilters.experience_level).flatMap(item => item.split(',').map(s => s.trim()))));
  const [allExperienceLevels, setAllExperienceLevels]= useState<FilterProps>();
  const [exploreAllJobs, setExploreAllJobs] = useState(false);
  const [experience_level, setExperience_level] = useState<FilterProps>();
  const [saveExpData, setSaveExpData] = useState<FilterItem[]>([]);
 
    const settings = {
      dots: false,
      arrows: false,
      infinite: false,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: true,
    };

    useEffect(() => {
      const fetchFilterOptions = async () => {
        try {     
          
          setExperience_level(allExperienceLevels);

          const cleanedFilters = Object.fromEntries(
            Object.entries(initialFilters).filter(([_, value]) => value instanceof Set ? value.size > 0 : Boolean(value))
          );
          
          const response = await fetchfilters({filters: Object.fromEntries(Object.entries(cleanedFilters).map(([key, value]) => [key, Array.from(value)])), countryCode: cCode, search: keyword});
          const allFilters: FilterOptions = response;

          allFilters.data.map(filter => {
            if(filter.type === "experience_level"){
              if(saveExpData.length > 0 ) {
                setAllExperienceLevels({...filter, item: saveExpData});               
              } else {
                setAllExperienceLevels(filter);
            }
          }});       
        } catch (error) {
          console.error('Error fetching filter options:', error);         
        }
      };
  
      fetchFilterOptions();
    }, [onFilterSelect, initialFilters, keyword]);

    const handleCheckboxChangeCarousel = useCallback((value: string) => {
      setSelectedCarouselFilters(prevFilters => {
        const updatedFilters = new Set(prevFilters);
  
        if (updatedFilters.has(value) || initialFilters.experience_level.has(value)) {
          updatedFilters.delete(value);
        } else {
          updatedFilters.add(value);
        }
  
        // Call the onFilterSelect with the updated filters
        onFilterSelect(updatedFilters);

        if (updatedFilters.size !== 0) setExploreAllJobs(false);
        
        return updatedFilters;
      });
      setAllExperienceLevels(experience_level);
    }, [onFilterSelect]);

    useEffect(() => {
      setSelectedCarouselFilters(new Set(Array.from(initialFilters.experience_level).flatMap(item => item.split(',').map(s => s.trim()))))
    },[initialFilters])

    const container = document.querySelector("#cg-jobs-search-root") as HTMLElement;
    if(container) container.style.overflowX = 'hidden';  
    
    const slickList = document.querySelector(".slick-list") as HTMLElement;
    if(slickList) slickList.style.overflow = 'visible';

    function updateLabel(label:string){
      const updatedLabel = label.charAt(0).toUpperCase() + label.slice(1).replace(/_/g, ' ');
      return updatedLabel.replace(/,(\S)/g, ', $1');
    } 

    return (
        <div className={styles["carousel-container"]}>
           <ul className={styles['filter-list']}>
          <Slider {...settings} className={styles['my-custom-slider']}>              
              {allExperienceLevels?.item.sort((a, b) => {
                  if (a.value.toLowerCase() === 'others') return 1; // Move 'Others' to the end
                  if (b.value.toLowerCase() === 'others') return -1; // Move 'Others' to the end
                  return 0; // Otherwise, maintain the original order
                }).map((childItem, index) => (                
                  <li 
                    key={childItem.value} 
                    className={[styles["carousel-slide"], childItem.count === 0 ? styles['no-job'] : ''].join(" ")}
                  >
                    <input 
                      type="checkbox"
                      id={`${childItem.value}-${index}`}
                      checked={Array.from(selectedCarouselFilters).flatMap(value => value.split(',')).map(value => value).includes(childItem.value)}
                      onChange={() => {
                        handleCheckboxChangeCarousel(childItem.value)
                        setSaveExpData(allExperienceLevels.item)
                      }}
                    />
                    <label htmlFor={`${childItem.value}-${index}`}>{updateLabel(childItem.value)}</label>
                  </li>
                ))}
        </Slider>
        </ul>   
      </div>
    );
  };